// Large static networks are prepared in small batches in the browser. The
// synchronous callers consume the same steps without scheduling overhead.
type Steps<T> = Readonly<Pick<Generator<void, T, void>, 'next'>>;

export function finish<T>(steps: Steps<T>): T {
  let step = steps.next();
  while (step.done !== true) step = steps.next();
  return step.value;
}

export const nextTask = (): Promise<void> =>
  new Promise((resolve) => {
    const channel = new MessageChannel();
    channel.port1.addEventListener(
      'message',
      () => {
        channel.port1.close();
        channel.port2.close();
        resolve();
      },
      { once: true },
    );
    channel.port1.start();
    channel.port2.postMessage(null);
  });

export async function cooperate<T>(steps: Steps<T>, signal?: AbortSignal): Promise<T> {
  // Separate consecutive preparation stages as well as batches within one.
  await nextTask();
  const started = performance.now();
  for (;;) {
    signal?.throwIfAborted();
    const step = steps.next();
    if (step.done === true) return step.value;
    if (performance.now() - started >= 8) return cooperate(steps, signal);
  }
}
